import { CHANNELTYPE } from "../../services/data"
import axiosClient, { ResponseSuccess, ResponseSuccessTotal } from "../axiosClient"
import { ITag } from "../selectOption/selectOptionsApi"


//#region Mãu
export interface IBrandConfigs {
  id: number
  brandName: string
  messageType: string
  phoneNumber: string
  categories: string
  units: string
  categoryCarIds: number[]
}

export interface ITemplate {
  id: number
  content: string
}

export interface INotificationTemplate {
  id: number
  code: string
  title: string
  titleEmail: string
  content: string
  status: number
  createdAt: string
  adminName: string
  categories: string
  providerId: number
  providerName: string
  type: CHANNELTYPE
  brandConfigs: IBrandConfigs[]
  typeZNSId?: number
  typeZNSName?: string
  templateId?: number
}

export interface ITemplateZaloFromConek {
  template_id: number
  content: string
  param: string
}

export const getListTemplate = async (
  limit?: number, pageNumber?: number, type?: CHANNELTYPE, adminId?: number[],
  dateStart?: string, dateEnd?: string, search?: string
) => {
  const path = "notificationTemplate/listTemplate"
  const params = {
    limit, pageNumber, type, adminId,
    dateStart, dateEnd, search
  }
  const result: ResponseSuccessTotal<INotificationTemplate[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

//Danh sách BrandConfigs theo nhà cung cấp
export const getListBrandConfigs = async (
  providerId: number
) => {
  const path = "/notificationTemplate/listBrandConfigs"
  const params = {
    providerId
  }
  const result: ResponseSuccess<IBrandConfigs[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

//Danh sách BrandConfigs theo nhà cung cấp ZNS
export const getListBrandNames = async (
  type: CHANNELTYPE
) => {
  const path = "/notificationTemplate/listBrandNames"
  const params = {
    type
  }
  const result: ResponseSuccess<IBrandConfigs[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

//thông tin mẫu thông báo
export const getInfoNotificationTemplate = async (id: number) => {
  const path = "notificationTemplate/infoNotificationTemplate"
  const params = {
    id
  }
  const result: ResponseSuccess<INotificationTemplate> = await axiosClient.get(
    path, { params }
  );
  return result;
};


//	Thêm mới mẫu thông báo thành công
export const addNotificationTemplate = async (
  title: string, content: string, type: CHANNELTYPE, brandNameIds?: number[],
  titleEmail?: string, typeZNSId?: number, providerId?: number, templateId?: number
) => {
  const url = "/notificationTemplate/addNotificationTemplate";
  const params = {
    title, providerId,
    content, type, brandNameIds,
    titleEmail, typeZNSId, templateId
  }
  const result: ResponseSuccess<[]> = await axiosClient.post(
    url, params
  );
  return result;
}

//	Thêm mới mẫu thông báo thành công
export const getInfoTemplate = async (
  id: number
) => {
  const url = "/notificationTemplate/infoTemplate";
  const params = {
    id
  }
  const result: ResponseSuccess<ITemplate> = await axiosClient.get(
    url, { params }
  );
  return result;
}

export const getTemplateZaloFromConek = async (
) => {
  const url = "/notificationTemplate/getTemplateZaloFromConek";
  const params = {
  }
  const result: ResponseSuccess<ITemplateZaloFromConek[]> = await axiosClient.get(
    url, { params }
  );
  return result;
}


//Cập nhật trạng thái Mẫu
export const activeNotificationTemplate = async (id: Number) => {

  const url = `notificationTemplate/activeNotificationTemplate`;
  const params = {
    id
  }
  const result: ResponseSuccess<[]> = await axiosClient.put(
    url, params
  );
  return result;
}
//	cập nhật mẫu thông báo thành công
export const editNotificationTemplate = async (
  id: number, title: string, content: string,
  providerId?: number, brandNameIds?: number[], titleEmail?: string, typeZNSId?: number, templateId?: number
) => {
  const url = "/notificationTemplate/editNotificationTemplate";
  const params = {
    id, title, providerId, brandNameIds,
    content,
    titleEmail, typeZNSId, templateId
  }
  const result: ResponseSuccess<[]> = await axiosClient.put(
    url, params
  );
  return result;
}

//Xóa mẫu thông báo
export const deleteNotificationTemplate = async (
  id: Number
) => {
  const url = `/notificationTemplate/deleteNotificationTemplate`;
  const params = {
    id
  }
  const result: ResponseSuccess<[]> = await axiosClient.delete(
    url, { params }
  );
  return result;
}

//#endregion
//--------------------------------------------------------------------------------------------

//#region Chiến dịch

export interface IListConfigTemplate {
  brandNames: ITag[]
  templates: ITag[]
  categories?: string
}
export const getListConfigTemplate = async (
  permittedCategoryCardIds: number[], type: CHANNELTYPE,
  unitId?: number, brandNameId?: number, notificationTemplateId?: number,
) => {
  const path = "campaign/listConfigTemplate";
  const params = {
    permittedCategoryCardIds, type,
    unitId, brandNameId, notificationTemplateId,
  }
  const result: ResponseSuccess<IListConfigTemplate> = await axiosClient.get(path, {
    params,
  });

  return result;
};
//#endregion

